/* ═══════════════════════════════════════════════════════════════════
   MATRIKAR — Cart Drawer JS (externalized P6 — 2026-05-22)
   Source : sections/cart-drawer.liquid (block 2, formerly inline)
   Loaded : defer, on every page (cart-drawer is global)
   Reads bootstrap inline globals : window.MK_CART_CURRENCY_ISO,
                                    window.MK_CART_TRASH_ICON_SVG
   ═══════════════════════════════════════════════════════════════════ */

(function () {
  // ---------- DOM Elements ----------
  const drawer = document.getElementById('mkCartDrawer');
  const backdrop = document.getElementById('mkCartBackdrop');
  const cartItemsContainer = document.getElementById('mkCartItems');
  const cartEmptyDiv = document.getElementById('mkCartEmpty');
  const cartTotalsSpan = document.getElementById('mkCartTotals');
  const cartCountSpan = document.getElementById('mkCartCount');
  const checkoutTotalSpan = document.getElementById('mkCheckoutTotal');

  let cachedCart = null;
  let isFetching = false; // simple guard — does NOT block UI open

  // HOTFIX_BUNDLE_SYSTEM_V22 — currency code USD/CAD via cart.currency.iso_code (server-side injection)
  function formatMoney(amount) {
    return '$' + parseFloat(amount).toFixed(2);
  }
  // P-PROMO : version AVEC code devise — réservée au subtotal / total checkout.
  function formatMoneyWithCode(amount) {
    var code = (window.MK_CART_CURRENCY_ISO || 'USD');
    return formatMoney(amount) + ' ' + code;
  }
  function getProductImage(item) {
    if (!item.image) return null;
    // P-CART perf #1 : vignette ~88px -> sert 176px (retina) au lieu du master full-res
    return item.image + (item.image.indexOf('?') === -1 ? '?' : '&') + 'width=176';
  }

  // P6 EXTRACT : trash icon SVG (was inline Liquid render 'icon' matrikar-trash)
  // Source : snippets/icon.liquid when 'matrikar-trash'
  const TRASH_ICON_SVG = (window.MK_CART_TRASH_ICON_SVG || '<svg aria-hidden="true" focusable="false" fill="none" width="18" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg>');

  // ---------- Static review stars (★★★★⭑ 4.8/5 · "(1,800)") ----------
  // Display-only. Mirrors snippets/mk-cart-review-stars.liquid exactly so the
  // drawer and the /cart page render an identical line. NO Ali Reviews / fetch.
  // 4 full stars (#FFC107) + 1 filled 80% via SVG <linearGradient> stop@80%
  // (reuses the matrikar-star-rating.liquid technique). `uid` keeps the
  // gradient id unique per cart line so no duplicate element ids appear.
  const STAR_FULL_SVG = '<svg width="13" height="13" viewBox="0 0 16 16" fill="#FFC107" xmlns="http://www.w3.org/2000/svg" focusable="false" style="display:block;"><path d="M8 0l2.47 5L16 5.82l-4 3.9.94 5.5L8 12.6l-4.94 2.62L4 9.72 0 5.82 5.53 5z"/></svg>';
  function reviewStarsHtml(uid) {
    return '<div class="mk-cart-stars" aria-label="Rated 4.8 out of 5 stars, over 1,800 reviews" style="display:flex;align-items:center;gap:5px;margin:0 0 3px;line-height:1;">'
      + '<span aria-hidden="true" style="display:inline-flex;gap:1px;">'
      + STAR_FULL_SVG + STAR_FULL_SVG + STAR_FULL_SVG + STAR_FULL_SVG
      + '<svg width="13" height="13" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" focusable="false" style="display:block;"><defs><linearGradient id="mkCartStar' + uid + '"><stop offset="80%" stop-color="#FFC107"/><stop offset="80%" stop-color="#E0E0E0"/></linearGradient></defs><path d="M8 0l2.47 5L16 5.82l-4 3.9.94 5.5L8 12.6l-4.94 2.62L4 9.72 0 5.82 5.53 5z" fill="url(#mkCartStar' + uid + ')"/></svg>'
      + '</span>'
      + '<span style="font-family:\'Urbanist\',system-ui,-apple-system,sans-serif;font-weight:600;font-size:12px;letter-spacing:0.02em;color:#717182;">(1,800+)</span>'
      + '</div>';
  }

  // ---------- Fetch helpers ----------
  async function fetchCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  // ---------- Core refresh — always runs, no lock ----------
  async function refreshCartDrawer() {
    if (isFetching) return;
    isFetching = true;
    try {
      const cart = await fetchCart();
      cachedCart = cart;
      window.currentCart = cart;
      renderCartItems(cart);
      renderTotals(cart);
    } catch (err) {
      console.error('Cart refresh error:', err);
    } finally {
      isFetching = false;
    }
  }

  // ---------- Render ----------

  // Keys to rename for display
  const KEY_LABELS = {
    'Number of seats': 'Coverage',
    'Select Set':      'Coverage',
  };
  function getDisplayKey(key) {
    return KEY_LABELS[key] || key;
  }
  function isValidPropertyKey(key) {
    return !key.startsWith('_');
  }

  // Property display order: Option/Coverage first, then vehicle info
  const PROP_ORDER = [
    'Option', 'Select Set', 'Number of seats',
    'Vehicle', 'Vehicle Year', 'Trim', 'Seats', 'Drive Side', 'Fuel Type',
  ];
  function sortProps(entries) {
    return entries.slice().sort(([a], [b]) => {
      const ai = PROP_ORDER.indexOf(a);
      const bi = PROP_ORDER.indexOf(b);
      if (ai === -1 && bi === -1) return 0;
      if (ai === -1) return 1;
      if (bi === -1) return -1;
      return ai - bi;
    });
  }

  /**
   * Mirror full-page cart Liquid logic:
   * 1. Look for explicit 'Option' and 'Coverage'/'Number of seats' properties
   * 2. If not found, extract from variant title split by ' / '
   *    — first segment = Option, second = Coverage
   * Returns { optionValue, coverageValue, remainingProps }
   */
  function extractOptionCoverage(item) {
    const props = item.properties || {};
    let optionValue = '';
    let coverageValue = '';
    const remaining = []; // all other valid props

    for (const [k, v] of Object.entries(props)) {
      if (!v || !isValidPropertyKey(k)) continue;
      const kd = k.toLowerCase();
      if (kd === 'option') {
        optionValue = v;
      } else if (kd === 'coverage' || kd === 'number of seats' || kd === 'select set') {
        coverageValue = v;
      } else {
        remaining.push([k, v]);
      }
    }

    // Fallback: parse from variant title (e.g. "All Black - Diamond / Front Only")
    const vt = item.variant_title;
    if (vt && vt !== 'Default Title') {
      const parts = vt.split(/\s*\/\s*/);
      if (!optionValue && parts[0]) optionValue = parts[0].trim();
      if (!coverageValue && parts[1]) coverageValue = parts[1].trim();
    }

    return { optionValue, coverageValue, remaining };
  }

  function renderCartItems(cart) {
    const foot = document.querySelector('.cart-foot');
    if (!cart.items.length) {
      cartItemsContainer.innerHTML = '';
      cartEmptyDiv.classList.add('visible');
      if (foot) foot.style.display = 'none';
      return;
    }
    cartEmptyDiv.classList.remove('visible');
    if (foot) foot.style.display = '';

    let html = '';
    for (const item of cart.items) {
      const lineTotal = item.final_line_price / 100;
      const compareTotal = item.original_line_price / 100;

      // Extract Option + Coverage exactly like full-page Liquid cart
      const { optionValue, coverageValue, remaining } = extractOptionCoverage(item);

      // Build props HTML: Option → Coverage → vehicle props (sorted)
      let propsHtml = '';
      if (optionValue)   propsHtml += `<div class="cart-prop"><strong>Option:</strong> ${optionValue}</div>`;
      if (coverageValue) propsHtml += `<div class="cart-prop"><strong>Coverage:</strong> ${coverageValue}</div>`;

      // Remaining props sorted by vehicle order
      const sorted = sortProps(remaining);
      for (const [key, val] of sorted) {
        propsHtml += `<div class="cart-prop"><strong>${getDisplayKey(key)}:</strong> ${val}</div>`;
      }

      // Title = product title only (Option/Coverage shown as props below)
      const displayTitle = item.product_title;

      // Static review stars under title — excluded on the BXGY free gift
      const isGiftLine = !!(item.properties && item.properties._free_gift === 'diamond-trunk-small');
      const starsHtml = isGiftLine ? '' : reviewStarsHtml('D' + String(item.key).replace(/[^a-zA-Z0-9]/g, ''));

      const imgUrl = getProductImage(item);
      html += `
        <div class="cart-item" data-key="${item.key}">
          <button class="cart-item-trash" data-key="${item.key}" aria-label="Remove ${item.title}">
            ${TRASH_ICON_SVG}
          </button>
          <div class="cart-item-img" data-zoom-handle="${item.handle}">${imgUrl ? `<img src="${imgUrl}" alt="${item.title}" width="80" height="80" loading="lazy" decoding="async">` : '<span class="cart-item-img-ph">Image</span>'}</div>
          <div class="cart-item-info">
            ${starsHtml}
            <h3 class="cart-item-name">${displayTitle}</h3>
            <div class="cart-item-props">${propsHtml}</div>
            <div class="cart-item-bottom">
              <div class="cart-qty">
                <button class="cart-qty-btn" data-key="${item.key}" data-delta="-1" aria-label="Decrease quantity" ${item.quantity <= 1 ? 'disabled' : ''}>−</button>
                <span class="cart-qty-num">${item.quantity}</span>
                <button class="cart-qty-btn" data-key="${item.key}" data-delta="1" aria-label="Increase quantity">+</button>
              </div>
              <div class="cart-item-price-block">
                ${compareTotal > lineTotal ? `<span class="cart-item-compare">${formatMoney(compareTotal)}</span>` : ''}
                <span class="cart-item-price">${formatMoney(lineTotal)}</span>
              </div>
            </div>
            ${compareTotal > lineTotal ? `<div class="cart-item-savings">(Save ${formatMoney(compareTotal - lineTotal)})</div>` : ''}
          </div>
        </div>
      `;
    }
    cartItemsContainer.innerHTML = html;
    attachFastEvents();
  }

  function attachFastEvents() {
    document.querySelectorAll('.cart-item-trash').forEach((btn) => {
      btn.addEventListener('click', trashHandler);
    });
    document.querySelectorAll('.cart-qty-btn').forEach((btn) => {
      btn.addEventListener('click', qtyHandler);
    });
  }

  const trashHandler = async (e) => {
    const key = e.currentTarget.getAttribute('data-key');
    if (!key) return;
    try {
      await updateCartItem(key, 0);
      cachedCart = null;
      await refreshCartDrawer();
    } catch (err) {
      console.error(err);
    }
  };

  const qtyHandler = async (e) => {
    const btn = e.currentTarget;
    const key = btn.getAttribute('data-key');
    const delta = parseInt(btn.getAttribute('data-delta'), 10);
    if (!key || isNaN(delta)) return;
    const item = window.currentCart?.items?.find((i) => i.key === key);
    if (!item) return;
    const newQty = item.quantity + delta;
    if (newQty < 1) return;
    // Optimistic UI
    const qtySpan = btn.parentElement.querySelector('.cart-qty-num');
    if (qtySpan) qtySpan.innerText = newQty;
    const allBtns = btn.parentElement.querySelectorAll('.cart-qty-btn');
    allBtns.forEach((b) => (b.style.pointerEvents = 'none'));
    try {
      await updateCartItem(key, newQty);
      cachedCart = null;
      await refreshCartDrawer();
    } catch (err) {
      if (qtySpan) qtySpan.innerText = item.quantity;
      console.error(err);
    } finally {
      allBtns.forEach((b) => (b.style.pointerEvents = ''));
    }
  };

  async function updateCartItem(key, quantity) {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: { [key]: quantity } }),
    });
    if (!response.ok) throw new Error('Update failed');
    return response.json();
  }

  function renderTotals(cart) {
    const subtotal = cart.total_price / 100;
    // HOTFIX_BUNDLE_SYSTEM_V22 — afficher cart-level discount "You saved" si actif (cart.total_discount, en cents)
    const totalDiscount = (cart.total_discount || 0) / 100;
    let html = '<div class="cart-total-row"><span>Shipping</span><span class="cart-total-val free">FREE</span></div>';
    if (totalDiscount > 0) {
      html += `<div class="cart-total-row savings"><span>You saved</span><span class="cart-total-val">−${formatMoney(totalDiscount)}</span></div>`;
    }
    html += `<div class="cart-total-row subtotal"><span>Subtotal</span><span class="cart-total-val">${formatMoneyWithCode(subtotal)}</span></div>`;
    cartTotalsSpan.innerHTML = html;
    checkoutTotalSpan.innerText = formatMoneyWithCode(subtotal);
    cartCountSpan.innerText = `(${cart.item_count})`;
  }

  // ---------- Drawer open/close ----------
  function openDrawer() {
    // Open immediately — don't wait for fetch
    drawer.classList.add('open');
    backdrop.classList.add('open');
    document.body.style.overflow = 'hidden';
    document.querySelector('.cart-close')?.focus();
    // Refresh in background (always fetch fresh on open)
    cachedCart = null;
    refreshCartDrawer();
  }

  function closeDrawer() {
    drawer.classList.remove('open');
    backdrop.classList.remove('open');
    document.body.style.overflow = '';
  }

  // ---------- Cart icon binding ----------
  function bindCartIcon() {
    const selectors = [
      '.site-header__cart',
      '.cart-icon',
      '.header__icon--cart',
      '#cart-icon',
      '[data-cart-toggle]',
      '.js-cart-count',
    ];
    let found = false;
    for (const sel of selectors) {
      const el = document.querySelector(sel);
      if (el) {
        el.addEventListener('click', (e) => {
          e.preventDefault();
          openDrawer();
        });
        found = true;
        break;
      }
    }
    // Fallback: intercept any /cart href except /checkout and /cart/add
    if (!found) {
      document.querySelectorAll('a[href="/cart"]').forEach((a) => {
        a.addEventListener('click', (e) => {
          e.preventDefault();
          openDrawer();
        });
      });
    }
    // Global escape hatch
    window.openMatrikarCart = openDrawer;
  }

  // ---------- Dynamic Express Checkout ----------
  function getCheckoutUrl() {
    // Use Shopify's dynamic checkout token if available
    if (window.Shopify && window.Shopify.checkout && window.Shopify.checkout.token) {
      return '/checkouts/' + window.Shopify.checkout.token;
    }
    return '/checkout';
  }

  function navigateToCheckout(provider) {
    const base = getCheckoutUrl();
    // Each provider uses the same checkout URL; Shopify renders the right button
    // based on shop payment settings. We pass a source hint via query param.
    const url = provider ? base + '?payment=' + encodeURIComponent(provider) : base;
    window.location.href = url;
  }

  // ---------- Listen for add-to-cart events from theme / 3rd-party ----------
  // Shopify native cart:updated event (newer themes)
  document.addEventListener('cart:updated', () => {
    cachedCart = null;
    refreshCartDrawer();
    openDrawer();
  });

  // HOTFIX_ATC_DRAWER : couvrir les events dispatched par <product-form>
  // natif Shopify Prestige (variant:add + cart:change) — fix gros ATC
  document.addEventListener('variant:add', () => {
    cachedCart = null;
    refreshCartDrawer();
    openDrawer();
  });

  document.addEventListener('cart:change', () => {
    cachedCart = null;
    refreshCartDrawer();
    openDrawer();
  });

  // Shopify Sections / AJAX API: intercept fetch/XHR to /cart/add
  // Works for any theme that calls /cart/add.js or /cart/add
  const _origFetch = window.fetch;
  window.fetch = async function (...args) {
    const result = await _origFetch.apply(this, args);
    const url = (args[0] || '').toString();
    const method = (args[1]?.method || 'GET').toUpperCase();
    // Only intercept POST requests to /cart/add — never GET /cart
    if (method === 'POST' && /\/cart\/add/.test(url)) {
      result
        .clone()
        .json()
        .then((data) => {
          // Only open drawer if add was successful (has variant_id or id)
          if (data && (data.variant_id || data.id || data.items)) {
            cachedCart = null;
            refreshCartDrawer();
            openDrawer();
          }
        })
        .catch(() => {});
    }
    return result;
  };

  // [P2.3 cleanup 2026-05-20] jQuery AJAX hook retire — aucun jQuery charge sur le site
  // (verifie par grep complet : ni dans layout/sections/snippets/assets, ni dans les apps
  // installees listees dans TRACKING_MAP.md). Le hook XHR ci-dessous couvre les ATC
  // d'apps tierces (Shop Pay, Klaviyo, etc.) qui utilisent XMLHttpRequest.

  // XHR fallback for very old themes
  const _origXhrOpen = XMLHttpRequest.prototype.open;
  const _origXhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._mkUrl = url;
    return _origXhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this._mkUrl && /\/cart\/add/.test(this._mkUrl)) {
      this.addEventListener('load', () => {
        cachedCart = null;
        refreshCartDrawer();
        openDrawer();
      });
    }
    return _origXhrSend.apply(this, arguments);
  };

  // ---------- Init ----------
  // P6 EXTRACT NOTE : script is deferred → DOMContentLoaded may have already fired by the time we run.
  // Handle both cases : if DOM still loading, wait; otherwise run init immediately.
  function init() {
    bindCartIcon();
    // Silently preload cart data
    fetchCart()
      .then((cart) => {
        cachedCart = cart;
        window.currentCart = cart;
        renderCartItems(cart);
        renderTotals(cart);
      })
      .catch(console.error);

    // Button events
    document.getElementById('mkCloseCartBtn')?.addEventListener('click', closeDrawer);
    backdrop?.addEventListener('click', closeDrawer);
    document.getElementById('mkCheckoutBtn')?.addEventListener('click', () => navigateToCheckout(null));
    // HOTFIX_EXPRESS_CHECKOUT_BUTTONS : 4 handlers retirés (mkApplePayBtn, mkGooglePayBtn, mkPayPalBtn, mkShopPayBtn).
    // Les boutons sont désormais rendus par le filtre payment_button natif Shopify qui gère ses propres event handlers + flow natif (Apple Pay sheet, Google Pay popup, Shop Pay accelerated, PayPal redirect).
    document.getElementById('mkShopNowBtn')?.addEventListener('click', () => {
      closeDrawer();
      window.location.href = '/collections/all';
    });
    document.getElementById('mkViewFullCartLink')?.addEventListener('click', (e) => {
      e.stopPropagation();
      closeDrawer();
      window.location.href = '/cart';
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer?.classList.contains('open')) closeDrawer();
    });
  }

  // Image zoom : déplacé dans assets/mk-image-zoom.js (module PARTAGÉ drawer + page cart),
  // chargé globalement via layout/theme.liquid. Les vignettes portent data-zoom-handle ;
  // le module délègue au niveau document → rien à câbler ici.

  if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
